let ymapsPromise = null;

export function initYmaps3(apiKey = null) {
  if (ymapsPromise) return ymapsPromise;

  ymapsPromise = new Promise((resolve, reject) => {
    apiKey = apiKey ? apiKey : import.meta.env.VITE_YMAP3_API_KEY;
    if (!apiKey) {
      reject(new Error('VITE_YMAP3_API_KEY is missing'));
      return;
    }

    if (typeof ymaps3 !== 'undefined') {
      ymaps3.ready.then(resolve);
      return;
    }

    console.log('🗺️ Yandex Maps: Adding script...');

    const script = document.createElement('script');
    script.src = `https://api-maps.yandex.ru/v3/?apikey=${apiKey}&lang=ru_RU`;
    script.async = true;

    script.onload = () => {
      console.log('🗺️ Yandex Maps: API loaded!');
      ymaps3.ready.then(resolve);
    };

    script.onerror = () => {
      reject(new Error('Failed to load Yandex Maps script'));
    };

    document.head.appendChild(script);
  });

  return ymapsPromise;
}
